import "./index.css";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProdWaterUsage from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import waterIcon from "../../../../../assets/new-product-detail-cats/sub-icons/product-water-usage-icon.svg";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProdWaterUsageContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("WATER_USAGE_INFO")}
        subDescription={t("WATER_USAGE_DESC")}
        isNormal={true}
        number={"31.3"}
        icon={waterIcon}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-waterusage-lca-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProdWaterUsage productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProdWaterUsageContents;
